package org.zq.astrock_ai.ui

enum class AppScreen {
    MarketCenter,
    StockDetail,
    Watchlist,
    Research,
}
